import React from 'react'
import CarePlanItem from '../CarePlanItem'
import { CAREPLAN_VALUE_TYPES } from '../../../../constants/carePlanValueTypes'
export default class WeeklyActivityTargetItem extends CarePlanItem {
  constructor (props) {
    super(props)
    this.type = 'activity_target'
    this.subtype = 'weekly'
  }

  getValueInput () {
    return this.getInputElement(
      10, 300, 5,
      CAREPLAN_VALUE_TYPES.VALUE.get(),
      CAREPLAN_VALUE_TYPES.VALUE.set()
    )
  }

  getThresholdInput () {
    return this.getInputElement(
      5, 100, 5,
      CAREPLAN_VALUE_TYPES.THRESHOLD.get(val => val + 100),
      CAREPLAN_VALUE_TYPES.THRESHOLD.set(val => val - 100)
    )
  }

  renderGoal () {
    return (
      <div>
        Moderate activity weekly for {this.getValueInput()} minutes
      </div>
    )
  }

  renderCondensed () {
    return null
  }
}
